import React from 'react'
import ToggleSwitch from './ToggleSwitch'

class Layers extends React.Component {
  constructor(props) {
    super(props);

    // states for map layers
    this.state = {
      layers: [
        {
          id: 'cc',
          name: "Clubcommision Mitglied",
          checked: false
        },
        {
          id: 4,
          name: "Status",
          checked: false
        },
        {
          id: 'corona',
          name: "Corona",
          checked: true
        },
        {
          id: 1,
          name: "B-pläne",
          checked: true
        },
        {
          id: 2,
          name: "Sanierungsgebiete",
          checked: false
        },
        {
          id: 'planziele',
          name: "Planziele 2030",
          checked: false
        }
        ]
  };


    // send layers to map data

    this.props.setLayers(this.state.layers);

  }

  onToggleLayerStatus = (toggledLayer) => {
    const layers  = this.state.layers;
    const nextLayerState = layers.map(layer => {
      if (toggledLayer.layerId !== layer.id) return layer;
      else {
        return {
          ...layer,
          checked: toggledLayer.checked
        };
      }
    });

    // update layer states and map data
    this.setState(prevState => ({ layers: nextLayerState }), () => {
      this.props.setLayers(this.state.layers);
      }
    );

  }

  render() {
    const layers = this.state.layers;


    //const {venue_layers } = {[layers].slice(0,4) }
    return (
      <div>
        <h4>Layers</h4>
        {layers.map(plan => (
            <ToggleSwitch
              key={plan.id}
              name={plan.name}
              layerId={plan.id}
              checked={plan.checked}
              onToggleLayer={this.onToggleLayerStatus}
            />
          ))}

      </div>
    );
  }
}

export default Layers
